import React, { useEffect } from 'react';
import jsPDF from 'jspdf';
import 'jspdf-autotable'; // Import the autoTable plugin
import moment from 'moment';
import autoTable from 'jspdf-autotable';
import { addPageNumber } from '../common/addPageNumber';

interface ExportSiteLabelReportProps {
    data: any;
    setPdfBlob: (blob: Blob) => void;
}

const ExportSiteLabelReport: React.FC<ExportSiteLabelReportProps> = ({ data, setPdfBlob }) => {
    const todayDate = moment().format('DD-MM-YYYY');

    const generatePDF = () => {
        const doc = new jsPDF({
            orientation: 'landscape',
            unit: 'mm',
            format: 'a4'
        });

        // Title
        doc.setFontSize(16);
        doc.text('Site Labels Report', 14, 15); // Start at (40,40) to leave margin space

        // Define columns for the report
        const columns = [
            { header: 'Address 1', dataKey: 'Address1' },
            { header: 'Address 2', dataKey: 'Address2' },
            { header: 'Address 3', dataKey: 'Address3' },
            { header: 'ATT', dataKey: 'ATT' },
        ];

        // Format the data for autoTable
        const tableData = data
            .map((item: any) => ({
                Address1: item.Address1,
                Address2: item.Address2,
                Address3: item.Address3,
                ATT: item.ATT,
            }));

        // Generate the table using autoTable
        autoTable(doc, {
            head: [columns.map(col => col.header)],
            body: tableData.map((row: { [s: string]: unknown; } | ArrayLike<unknown>) => Object.values(row)),
            theme: 'plain',
            startY: 20, // Start the table below the title
            styles: {
                fontSize: 10,
                cellPadding: 0.5,
                lineColor: 40,
                lineWidth: 0.1,
            },
            headStyles: {
                fontStyle: 'bold',
                textColor: 0,
                halign: 'center'
                // fillColor: [220, 220, 220], // Light gray background for the header
            },
            columnStyles: {
                0: { cellWidth: 70,halign: 'center' },  // Address 1
                1: { cellWidth: 70,halign: 'center' },  // Address 2
                2: { cellWidth: 70,halign: 'center' },  // Address 3
                3: { cellWidth: 60 },  // ATT
            },
        });

        addPageNumber(doc);
        const pdfBlob = doc.output('blob');
        setPdfBlob(pdfBlob);
    };

    useEffect(() => {
        if (data) {
            generatePDF();
        }
    }, [data]);

    return null; // No visual component, generates the PDF automatically
};

export default ExportSiteLabelReport;
